import React, { useContext, useEffect } from "react";
import { PublicLayout } from "./PublicLayout";
import { Navigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";

interface Props {
  children: JSX.Element | JSX.Element[];
}
export const PublicRoute = ({ children }: Props) => {
  const { validateToken, clientInfo, clientList, role } =
    useContext(AuthContext);
  if (validateToken() && role === "SUPER_ADMIN" && !clientList?.length) {
    return <Navigate to="/super-admin/users" replace />;
  }
  if (validateToken() && clientInfo) {
    return <Navigate to={`/dashboard/${clientInfo._id}`} replace />;
  } else {
    return <PublicLayout>{children}</PublicLayout>;
  }
};
